import _ from "lodash";

const NON_CRITERIA_KEYS = new Set([
  "limit",
  "offset",
  "order",
  "sort1",
  "sort2",
  "sort3",
  "tab",
]);
const NULL_OPERATORS = new Set(["isNull", "isNotNull"]);

const isNonCriteriaKey = key =>
  NON_CRITERIA_KEYS.has(key) || key.startsWith("selected");

const isEmptyValue = value =>
  value === undefined ||
  value === null ||
  (typeof value === "string" && value.trim() === "") ||
  (Array.isArray(value) && value.length === 0);

const isPlainObject = value =>
  typeof value === "object" && value !== null && !Array.isArray(value);

const isOperatorEntry = value => isPlainObject(value) && "operator" in value;

const getOperatorEntryCriteria = ({ operator, value }) =>
  NULL_OPERATORS.has(operator) || !isEmptyValue(value)
    ? { operator, value }
    : undefined;

// Reduces raw search form values to only the parts that actually filter:
// pagination, sorting, selection and empty or operator-only entries drop out.
const getSearchCriteria = values => {
  if (isOperatorEntry(values)) return getOperatorEntryCriteria(values);
  if (!isPlainObject(values)) return isEmptyValue(values) ? undefined : values;

  const criteria = Object.fromEntries(
    Object.entries(values)
      .filter(([key]) => !isNonCriteriaKey(key))
      .map(([key, value]) => [key, getSearchCriteria(value)])
      .filter(([, value]) => value !== undefined),
  );
  return Object.keys(criteria).length > 0 ? criteria : undefined;
};

const hasSearchCriteria = (values, defaultValues) =>
  values !== undefined &&
  !_.isEqual(getSearchCriteria(values), getSearchCriteria(defaultValues));

export { getSearchCriteria, hasSearchCriteria };
